export function generateRandomPassword(
  length = 12,
  includeDigits = true,
  includeSpecialChars = true,
): string {
  let chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

  if (includeDigits) {
    chars += '0123456789';
  }

  if (includeSpecialChars) {
    chars += '!@#$%^&*';
  }

  let password = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * chars.length);

    password += chars[randomIndex];
  }

  return password;
}
